module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Medium.3866b5ed.woff2";